import axios from 'axios'
import { showToast, showDialog } from 'vant'
import router from '@/router'
import store from '@/store'
import { API_CONFIG } from '@/config/config'

// 创建axios实例
const request = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: 10000,
  withCredentials: false, // 跨域请求时不发送cookies
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 添加认证信息
    const token = localStorage.getItem('google_token') || localStorage.getItem('wechat_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const { data } = response
    
    // Check business status code, handle 401 and 402 not logged in
    if (data && (data.code === 401 || data.code === 402)) {
      // Call store logout method
      store.dispatch('logout')
      
      // Clear wechat related local storage
      localStorage.removeItem('wechat_token')
      localStorage.removeItem('wechat_user_info')
      
      // Show login expired prompt
      showToast({
        message: data.msg || 'Login expired, please login again',
        type: 'fail',
        duration: 2000 // 2 seconds duration
      })
      
      // Navigate to profile page
      router.push({
        name: 'Profile'
      })
      
      return Promise.reject(new Error(data.msg || 'Login expired'))
    }
    
    // Handle business status code 400 (request parameter error etc)
    if (data && data.code === 400) {
      // Show error message from server
      showDialog({
        title: 'Request Error',
        message: data.msg || 'Request parameter error',
        confirmButtonText: 'OK'
      })
      
      return Promise.reject(new Error(data.msg || 'Request parameter error'))
    }
    
    // 直接返回完整的响应数据，让组件自己处理
    return data
  },
  error => {
    // Handle HTTP status code errors
    if (error.response) {
      const { status, data } = error.response
      
      if (status === 401 || status === 402) {
        // Call store logout method
        store.dispatch('logout')
        
        // Clear wechat related local storage
        localStorage.removeItem('wechat_token')
        localStorage.removeItem('wechat_user_info')
        
        // Show login expired prompt
        showToast({
          message: status === 402 ? 'Login expired, please login again' : 'You are not logged in, please login',
          type: 'fail',
          duration: 2000 // 2 seconds duration
        })
        
        // Navigate to profile page
        router.push({
          name: 'Profile'
        })
      } else {
        // Other HTTP errors
        const errorMessage = data?.msg || `Request failed (${status})`
        showDialog({
          title: 'Request Error',
          message: errorMessage,
          confirmButtonText: 'OK'
        })
        
        return Promise.reject(new Error(errorMessage))
      }
    } else {
      // Network error or other errors
      const errorMessage = 'Network connection failed, please check network settings'
      showDialog({
        title: 'Network Error',
        message: errorMessage,
        confirmButtonText: 'OK'
      })
      
      return Promise.reject(new Error(errorMessage))
    }
    
    return Promise.reject(error)
  }
)

export default request